import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
interface ProfilesEndedEventStore {
    isSwiped: boolean;
    setSwiped: (val: boolean) => void;
    isFiltersWasApplied: boolean;
    setFiltersWasApplied: (val: boolean) => void;
}
export const useProfilesEndedEvent = create<ProfilesEndedEventStore>()(
    devtools(
        immer((set, _) => ({
            isSwiped: false,
            setSwiped: (val: boolean) => set({
                isSwiped: val
            }),
            isFiltersWasApplied: false,
            setFiltersWasApplied: (val: boolean) => set({
                isFiltersWasApplied: val
            }),
        })),
    ),
);
